import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/list-duck";
import { IPermission } from "interfaces/permission";

const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "LIST_PERMISSIONS_" }
);

export interface ListPermissionsState extends IState {
  data: IPermission[];
}

interface ISuccessListUnitsAction extends ISuccessAction {
  data: IPermission[];
}

const INITIAL_STATE: ListPermissionsState = {
  data: [],
  loading: false,
  error: null,
};

const request = (state: ListPermissionsState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: ListPermissionsState, action: ISuccessListUnitsAction) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: ListPermissionsState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const listPermissions = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ListPermissionsTypes = Types;
export const ListPermissionsActions = Creators;
